import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
import { Routes, RouterModule } from '@angular/router';

import { AdminComponent } from './admin.component';
import { AuthGuard } from '../common/auth.guard';
import { ManageReleasesComponent } from '../managereleases/managereleases.component';
import { AddProductComponent } from 'app/add-product/add-product.component';
import { AuthorizationComponent } from 'app/authorization/authorization.component';

const ADMINROUTES: Routes = [
    {
        path: 'admin', component: AdminComponent,
        children: [
            { path: 'managereleases', component: ManageReleasesComponent, canActivate: [AuthGuard] },
            { path: 'addproduct', component: AddProductComponent, canActivate: [AuthGuard] },
            { path: 'authorization', component: AuthorizationComponent, canActivate: [AuthGuard] }
        ]
    }
];

export const ADMINROUTING: ModuleWithProviders = RouterModule.forChild(ADMINROUTES);



// WEBPACK FOOTER //
// ./src/app/admin/admin.routing.ts